<script>
    import StatusCard from 'views/components/statusCard/StatusCard.svelte'

    const { productName, useCenterPanel = false } = $props()
</script>

<div class:center-panel={useCenterPanel}>
    <StatusCard color="orange" icon="warning">
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        {@html window.i18n.sprintf(
            window.i18n.gettext('You have no access to <strong>%s</strong> yet. First link your Malmberg license to your account by opening your license via %s.'),
            _.escape(productName),
            '<a href="https://startmalmbergmbo.nl" target="_blank">startmalmbergmbo.nl</a>'
        )}
    </StatusCard>
</div>
